// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-header-container {
  height: 150px;
}
.profile-header-container .suspend-btn-conatiner {
  height: 100%;
  padding: 20px;
}

.round-status-common {
  width: 90px;
  height: 26px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.round-scheduled {
  border: 1px solid #2795ae;
  color: #2795ae !important;
}

.round-playing {
  border: 1px solid #40ec9c;
  color: #40ec9c !important;
}

.round-completed {
  border: 1px solid #2aae27;
  color: #2aae27 !important;
}

.round-canceled {
  border: 1px solid #ff2b2b;
  color: #ff2b2b !important;
}

.pofile-data-not-found {
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pofile-data-not-found span {
  font-weight: bold;
}

.btn-height {
  height: 40px;
}

.date-picker-contanier {
  /* Custom DatePicker Styles */
}
.date-picker-contanier .react-datepicker-popper {
  z-index: 999999999999;
}
.date-picker-contanier .react-datepicker__input-container input {
  height: 40px;
}
.date-picker-contanier .react-datepicker-wrapper {
  display: inline-block;
  width: 100%;
}
.date-picker-contanier .react-datepicker__input-container {
  width: 100%;
}
.date-picker-contanier .react-datepicker__input-container input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 12px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
  outline: none;
  transition: border 0.3s ease;
}
.date-picker-contanier .react-datepicker__input-container input:focus {
  border-color: #ad728b; /* Primary color */
}
.date-picker-contanier .react-datepicker {
  border-radius: 8px;
  border: 1px solid #ddd;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.1);
}
.date-picker-contanier .react-datepicker__header {
  background-color: #ad728b; /* Primary color */
  border-bottom: none;
  border-radius: 8px 8px 0 0;
}
.date-picker-contanier .react-datepicker__current-month,
.date-picker-contanier .react-datepicker__day-name {
  color: #fff;
}
.date-picker-contanier .react-datepicker__navigation-icon--next,
.date-picker-contanier .react-datepicker__navigation-icon--previous {
  top: 4px;
}
.date-picker-contanier .react-datepicker__day {
  color: #333;
  font-weight: bold;
  border-radius: 50%;
  margin: 0.5em;
  width: 2em;
  height: 2em;
  line-height: 2em;
}
.date-picker-contanier .react-datepicker__day:hover {
  background-color: #f0f0f0;
  border-radius: 50%;
  margin: 0.5em;
  width: 2em;
  height: 2em;
}
.date-picker-contanier .react-datepicker__day--selected {
  background-color: #ad728b; /* Primary color */
  color: #fff;
}
.date-picker-contanier .react-datepicker__day--keyboard-selected {
  background-color: white;
  color: #fff;
}
.date-picker-contanier .react-datepicker__day--today {
  border: 2px solid #ad728b; /* Primary color */
  color: #ad728b;
}
.date-picker-contanier .react-datepicker__day--disabled {
  color: #ccc;
  pointer-events: none;
}
.date-picker-contanier .react-datepicker__close-icon::after {
  background-color: black;
}
.date-picker-contanier .react-datepicker__day--selected:hover,
.date-picker-contanier .react-datepicker__day--in-selecting-range:hover,
.date-picker-contanier .react-datepicker__day--in-range:hover,
.date-picker-contanier .react-datepicker__month-text--selected:hover,
.date-picker-contanier .react-datepicker__month-text--in-selecting-range:hover,
.date-picker-contanier .react-datepicker__month-text--in-range:hover,
.date-picker-contanier .react-datepicker__quarter-text--selected:hover,
.date-picker-contanier .react-datepicker__quarter-text--in-selecting-range:hover,
.date-picker-contanier .react-datepicker__quarter-text--in-range:hover,
.date-picker-contanier .react-datepicker__year-text--selected:hover,
.date-picker-contanier .react-datepicker__year-text--in-selecting-range:hover,
.date-picker-contanier .react-datepicker__year-text--in-range:hover {
  background-color: #f0f0f0;
}
.date-picker-contanier .react-datepicker__day--selected,
.date-picker-contanier .react-datepicker__day--in-selecting-range,
.date-picker-contanier .react-datepicker__day--in-range,
.date-picker-contanier .react-datepicker__month-text--selected,
.date-picker-contanier .react-datepicker__month-text--in-selecting-range,
.date-picker-contanier .react-datepicker__month-text--in-range,
.date-picker-contanier .react-datepicker__quarter-text--selected,
.date-picker-contanier .react-datepicker__quarter-text--in-selecting-range,
.date-picker-contanier .react-datepicker__quarter-text--in-range,
.date-picker-contanier .react-datepicker__year-text--selected,
.date-picker-contanier .react-datepicker__year-text--in-selecting-range,
.date-picker-contanier .react-datepicker__year-text--in-range {
  background-color: #ad728b;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/pages/UserManagement/Style.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AAAI;EACI,YAAA;EACA,aAAA;AAER;;AAEA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AACA;EACI,yBAAA;EACA,yBAAA;AAEJ;;AAAA;EACI,yBAAA;EACA,yBAAA;AAGJ;;AADA;EACI,yBAAA;EACA,yBAAA;AAIJ;;AAFA;EACI,yBAAA;EACA,yBAAA;AAKJ;;AAFA;EACI,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAKJ;AAJI;EACI,iBAAA;AAMR;;AADA;EACI,YAAA;AAIJ;;AAFA;EACI,6BAAA;AAKJ;AAJI;EACI,qBAAA;AAMR;AAJI;EACI,YAAA;AAMR;AAJI;EACI,qBAAA;EACA,WAAA;AAMR;AAHI;EACI,WAAA;AAKR;AAFI;EACI,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,0CAAA;EACA,aAAA;EACA,4BAAA;AAIR;AADI;EACI,qBAAA,EAAA,kBAAA;AAGR;AAAI;EACI,kBAAA;EACA,sBAAA;EACA,2CAAA;AAER;AACI;EACI,yBAAA,EAAA,kBAAA;EACA,mBAAA;EACA,0BAAA;AACR;AAEI;;EAEI,WAAA;AAAR;AAEI;;EAEI,QAAA;AAAR;AAEI;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AAAR;AAGI;EACI,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;AADR;AAII;EACI,yBAAA,EAAA,kBAAA;EACA,WAAA;AAFR;AAKI;EACI,uBAAA;EACA,WAAA;AAHR;AAMI;EACI,yBAAA,EAAA,kBAAA;EACA,cAAA;AAJR;AAOI;EACI,WAAA;EACA,oBAAA;AALR;AAQI;EACI,uBAAA;AANR;AASI;;;;;;;;;;;;EAYI,yBAAA;AAPR;AAUI;;;;;;;;;;;;EAYI,yBAAA;EACA,WAAA;AARR","sourcesContent":[".profile-header-container {\n    height: 150px;\n    .suspend-btn-conatiner {\n        height: 100%;\n        padding: 20px;\n    }\n}\n\n.round-status-common {\n    width: 90px;\n    height: 26px;\n    border-radius: 4px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.round-scheduled {\n    border: 1px solid #2795ae;\n    color: #2795ae !important;\n}\n.round-playing {\n    border: 1px solid #40ec9c;\n    color: #40ec9c !important;\n}\n.round-completed {\n    border: 1px solid #2aae27;\n    color: #2aae27 !important;\n}\n.round-canceled {\n    border: 1px solid #ff2b2b;\n    color: #ff2b2b !important;\n}\n\n.pofile-data-not-found {\n    height: 350px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    span {\n        font-weight: bold;\n    }\n}\n\n//react-date-picker\n.btn-height {\n    height: 40px;\n}\n.date-picker-contanier {\n    /* Custom DatePicker Styles */\n    .react-datepicker-popper {\n        z-index: 999999999999;\n    }\n    .react-datepicker__input-container input {\n        height: 40px;\n    }\n    .react-datepicker-wrapper {\n        display: inline-block;\n        width: 100%;\n    }\n\n    .react-datepicker__input-container {\n        width: 100%;\n    }\n\n    .react-datepicker__input-container input {\n        width: 100%;\n        padding: 10px 12px;\n        border: 1px solid #ddd;\n        border-radius: 8px;\n        font-size: 12px;\n        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);\n        outline: none;\n        transition: border 0.3s ease;\n    }\n\n    .react-datepicker__input-container input:focus {\n        border-color: #ad728b; /* Primary color */\n    }\n\n    .react-datepicker {\n        border-radius: 8px;\n        border: 1px solid #ddd;\n        box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.1);\n    }\n\n    .react-datepicker__header {\n        background-color: #ad728b; /* Primary color */\n        border-bottom: none;\n        border-radius: 8px 8px 0 0;\n    }\n\n    .react-datepicker__current-month,\n    .react-datepicker__day-name {\n        color: #fff;\n    }\n    .react-datepicker__navigation-icon--next,\n    .react-datepicker__navigation-icon--previous {\n        top: 4px;\n    }\n    .react-datepicker__day {\n        color: #333;\n        font-weight: bold;\n        border-radius: 50%;\n        margin: 0.5em;\n        width: 2em;\n        height: 2em;\n        line-height: 2em;\n    }\n\n    .react-datepicker__day:hover {\n        background-color: #f0f0f0;\n        border-radius: 50%;\n        margin: 0.5em;\n        width: 2em;\n        height: 2em;\n    }\n\n    .react-datepicker__day--selected {\n        background-color: #ad728b; /* Primary color */\n        color: #fff;\n    }\n\n    .react-datepicker__day--keyboard-selected {\n        background-color: lighten(#ad728b, 50%);\n        color: #fff;\n    }\n\n    .react-datepicker__day--today {\n        border: 2px solid #ad728b; /* Primary color */\n        color: #ad728b;\n    }\n\n    .react-datepicker__day--disabled {\n        color: #ccc;\n        pointer-events: none;\n    }\n\n    .react-datepicker__close-icon::after {\n        background-color: black;\n    }\n\n    .react-datepicker__day--selected:hover,\n    .react-datepicker__day--in-selecting-range:hover,\n    .react-datepicker__day--in-range:hover,\n    .react-datepicker__month-text--selected:hover,\n    .react-datepicker__month-text--in-selecting-range:hover,\n    .react-datepicker__month-text--in-range:hover,\n    .react-datepicker__quarter-text--selected:hover,\n    .react-datepicker__quarter-text--in-selecting-range:hover,\n    .react-datepicker__quarter-text--in-range:hover,\n    .react-datepicker__year-text--selected:hover,\n    .react-datepicker__year-text--in-selecting-range:hover,\n    .react-datepicker__year-text--in-range:hover {\n        background-color: #f0f0f0;\n    }\n\n    .react-datepicker__day--selected,\n    .react-datepicker__day--in-selecting-range,\n    .react-datepicker__day--in-range,\n    .react-datepicker__month-text--selected,\n    .react-datepicker__month-text--in-selecting-range,\n    .react-datepicker__month-text--in-range,\n    .react-datepicker__quarter-text--selected,\n    .react-datepicker__quarter-text--in-selecting-range,\n    .react-datepicker__quarter-text--in-range,\n    .react-datepicker__year-text--selected,\n    .react-datepicker__year-text--in-selecting-range,\n    .react-datepicker__year-text--in-range {\n        background-color: #ad728b;\n        color: #fff;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
